import React, { useContext, useEffect, useState } from 'react'
import { Body, closeAnimation, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Tbody, Table, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import { getAxiosInstance, getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import Input2 from '../../NecttosComp/Input/Input2';
import { FirebaseContext } from '../../context/FirebaseContext';
import GoogleDocsCreator from '../../NecttosComp/Editor/GoogleDocsCreator';
import { CLIENT_ID } from '../../config/google';
import { Switch } from '@mui/material';
import MultiProgressBar from '../../NecttosComp/ProgressBar/MultiProgressBar';
import Search from 'antd/lib/transfer/search';
import toast, { Toaster } from "react-hot-toast";
import LoadingAnimation from '../../components/LoadingAnimation';
import GoogleDocsEditor from '../../NecttosComp/Editor/GoogleDocsEditor';
import Instruction from '../../Documentation/Instruction';

interface ddFSManagementProps {
  onClose: () => void;
}

const getAllTemplate = (collegeId: any) => async () => {
  const instance = await getAxiosTokenInstance();
  try {
    const resp = await instance.get('/college/action/getAllDDFSTemplates', {
      params: { collegeId },
    });
    if (resp.data.statusCode === 400) {
      throw new Error(resp.data.message || 'API Error');
    } else {
      return resp?.data?.list;
    }
  } catch (error) {
    throw new Error('API Error');
  }
};
const getAllDDFSFiles = (collegeId: any, userId: string) => async () => {
  const instance = await getAxiosTokenInstance();
  try {
    const resp = await instance.get('/college/action/getDDFS', {
      params: { collegeId, userId },
    });
    if (resp.data.statusCode === 400) {
      throw new Error(resp.data.message || 'API Error');
    } else {
      return resp?.data?.list;
    }
  } catch (error) {
    throw new Error('API Error');
  }
};

function DDFSDash({ onClose }: ddFSManagementProps) {
  const { collegeId, user } = useContext(FirebaseContext);
  const [values, setValues] = useState<any>({});
  const [selected, setSelected] = useState<any>({});
  const [showForm, setShowForm] = useState(false);
  const [docId, setDocId] = useState<string>('');
  const [loggedInUserEmail, setLoggedInUserEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false)
  const [isQueue, setIsQueue] = useState<boolean>(false)
  const [search, setSearch] = useState<string>('')
  const [tableData, setTableData] = useState<any>([])
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [myDoc, setMyDoc] = useState<any>([])
  const [viewDocs, setViewDocs] = useState<string>('')


  useEffect(() => {
    const email = localStorage.getItem("email");
    if (email) {
      setLoggedInUserEmail(email);
    } else {
      const existingScript = document.getElementById("google-identity-script");
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.id = "google-identity-script";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
        script.onload = () => {
          initGoogleIdentity();
        };
      } else {
        initGoogleIdentity();
      }
    }
  }, []);

  const initGoogleIdentity = () => {
    if (window.google && window.google.accounts) {
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: handleCredentialResponse,
      });
      renderSignInButton();
    }
  };

  const renderSignInButton = () => {
    const signInDiv = document.getElementById("googleSignInDiv");
    if (signInDiv && window.google && window.google.accounts) {
      window.google.accounts.id.renderButton(signInDiv, {
        theme: "outline",
        size: "large",
      });
    }
  };

  const handleCredentialResponse = (response: any) => {
    const token = response.credential;
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = JSON.parse(window.atob(base64));
    const userEmail = decodedPayload.email;

    setLoggedInUserEmail(userEmail);
    localStorage.setItem("email", userEmail);
    console.log("User email:", userEmail);
  };


  const { data: dropdown = [] } = useQuery('getAllDDFSTemplate', getAllTemplate(collegeId));
  const { data: table = [], refetch } = useQuery('getAllDDFSFiles', getAllDDFSFiles(collegeId, user.uid));

  useEffect(() => {
    let list;
    if (search) {
      const searchLower = search.toLowerCase();
      list = table.filter(
        (item: any) =>
          item.title?.toLowerCase().includes(searchLower) ||
          item.ddfsId?.toLowerCase().includes(searchLower)
      );
    } else {
      list = table;
    }
    if (isQueue) {
      list = list?.filter((itm: any) => itm.hierarchy.length !== 0);
    }
  
    if (JSON.stringify(list) !== JSON.stringify(tableData)) {
      setTableData(list);
    }
  }, [search, table, isQueue]);

  const handleNewDDFS = async () => {
    setLoading(true)
    const instance = await getAxiosTokenInstance();
    try {

      const { data } = await instance.post('/googleDocs/copyDoc',
        {
          title: values.title,
          email: loggedInUserEmail,
          docId: dropdown.find((item: any) => item._id === values.templateId)?.docId
        }
      )
      setDocId(data.docId)
      let status = dropdown.find((item: any) => item._id === values.templateId)?.hierarchy;


      const resp = await instance.post('/college/action/postDDFS', {
        ...values,
        collegeId,
        docId: data.docId,
        status: status.map((item: any) => { item.completed = false }),
        userId: user.uid
      });
      if (resp.data.statusCode === 400) {
        throw new Error(resp.data.message || 'API Error');
      } else {
        window.open(data.url, '_blank');
      }
    } catch (error) {
      throw new Error('API Error');
    } finally {
      setLoading(false)
    }

  }

  const handleDelete = async (id: string, docId: string) => {
    setLoading(true)
    const instance = await getAxiosTokenInstance();
    try {
      const { status } = await instance.post('/googleDocs/deleteDoc', {
        docId
      })
      if (status === 200) {
        const { data } = await instance.delete('/college/action/deleteDDFS', {
          params: { id }
        })
        if (data.statusCode == 200) {
          toast.success("Deleted Successfully")
          refetch()
        }
      }

    } catch (error) {
      toast.error('Unknown error occured please try again')
    }
    setLoading(false)
  }

  const handleApprove = async (item: any) => {
    const instance = await getAxiosInstance()
    try {

      for (const x of item.status) {
        delete x.role;
        if (x.completed) continue;
        x.completed = true;
        x.completedBy = user.uid;
        x.date = new Date().toISOString();
        break
      }

      const { data } = await instance.post('/college/action/postDDFS', {
        status: item.status,
        _id: item._id,
        userId: user.uid,
        title: values.title,
        collegeId
      })
      if (data.statusCode == 200) {
        toast.success("Approved Successfully")
        setIsEditing(false)
        setShowForm(false)
        refetch()
      } else {
        toast.error("Unknown error occured please try again")
      }

    } catch (error) {
      console.error(error);
      toast.error('Unknown error occured please try again')
    }
  }

  const handleMyDoc = () => {
    const list = table.filter((item: any) => item?.createdBy === user.uid);
    if (list.length === 0) {
      toast.error("No documents found");
    } else {
      setMyDoc(list);
    }
  }

  const downLoadDoc = async (docId: string) => {
    try {
      setLoading(true);
      const instance = await getAxiosTokenInstance();
  
      const response = await instance.post('/googleDocs/downloadSignedPdf', 
        { docId, collegeId }, 
        { responseType: 'blob' } 
      );
  
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'signed-document.pdf'); 
      document.body.appendChild(link);
      link.click();
  
      window.URL.revokeObjectURL(url); 
      document.body.removeChild(link);
    } catch (error) {
      toast.error('Unknown error occurred. Please try again.');
    }
    setLoading(false);
  };
  


  return (
    <>
      <Toaster />
      <Main title='DDFS Dashboard' width='100dvw' height='100dvh'>
        <Header >
          <Button
            type="save"
            onClick={() => { setShowForm(true) }}
          >
            + Add
          </Button>
          <Button
            type="doc"
            onClick={handleMyDoc}
          >
            My Documents
          </Button>
          <input placeholder="Search by ID/Title" value={search} onChange={(e) => setSearch(e.target.value)} type="text" className="w-72 h-[40px] mt-2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500" />

          <div className="flex items-center space-x-4">
            <div className="relative flex items-center space-x-2 bg-slate-300 dark:bg-slate-800 p-2 border border-gray-300 rounded">
              <div className="absolute -top-2 -left-2 flex items-center justify-center w-6 h-6 bg-red-600 text-white text-xs font-bold rounded-full">
                {tableData?.filter((itm: any) => itm.hierarchy.length !== 0)?.length}
              </div>
              <Switch checked={isQueue} onChange={(e) => setIsQueue(e.target.checked)} />
              <label className="text-sm font-medium text-gray-700 dark:text-white">Show My Queue</label>
            </div>
            <Instruction keyId={'ddFSDash'}/>
            <Button type="close" onClick={onClose}>
              Close
            </Button>
          </div>
        </Header>
        <Body>
          <div className="h-[75vh] pt-2 printable overflow-auto">
            <Table width="100%" innerWidth={['5%', !isQueue ? "10%" : "5%", !isQueue ? "25%" : '20%', '25%', '10%', '10%']}>
              <Thead>
                <Tr>
                  <Th position={0}>Sl.No.</Th>
                  <Th position={1}>DDFS ID</Th>
                  <Th position={2}>Title</Th>
                  <Th position={3}>Status</Th>
                  <Th position={4}>Document</Th>
                  {isQueue && <Th position={5}>Action</Th>}
                </Tr>
              </Thead>
              <Tbody height="auto">
                {tableData?.map((x: any, i: number) => (
                  <Tr key={i}>
                    <Td index={i} position={0}>
                      {i + 1}
                    </Td>
                    <Td index={i} position={1}>
                      {x.ddfsId}
                    </Td>
                    <Td index={i} position={2}>
                      {x?.title}
                    </Td>
                    <Td index={i} position={3}>
                      <MultiProgressBar points={x.status} containerWidth="75%" />
                    </Td>
                    <Td index={i} position={4} textAlign={'center'}>
                      {x?.docId && (
                        <>
                          {
                            !loading ? <Button type='doc' onClick={() => downLoadDoc(x.docId)}>
                              Download
                            </Button> : <LoadingAnimation customHeight={50} customWidth={50} />
                          }
                        </>
                      )}
                    </Td>
                    {isQueue && <Td index={i} position={5}>
                      <div className="flex justify-evenly flex-wrap">
                        <Button
                          type="update"
                          onClick={() => {
                            setValues(x);
                            setDocId(x?.docId);
                            setShowForm(true);
                            setIsEditing(true)
                          }}
                        >
                          Edit & Approve
                        </Button>
                        {x.createdBy == user.uid && <Button type="delete" onClick={() => handleDelete(x?._id, x?.docId)}>
                          Delete
                        </Button>}
                        {/* <Button type="save" onClick={() => handleDelete(x?._id, x?.docId)}>
                          Approve
                        </Button> */}
                      </div>
                    </Td>}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
        </Body>

      </Main>
      {showForm && (
        <Main width='80vw' height='100%' zIndex='1000'>
          <Header>
            <Button
              type='close'
              onClick={() => {
                closeAnimation();
                setTimeout(() => { setShowForm(false); setDocId(''); setValues({}); setIsEditing(false) }, 500);
              }}>
              Close
            </Button>

          </Header>
          <Body>
            <div className='flex flex-col w-full'>
              <Input2
                type="text"
                fieldName="Title *"
                returnKey="title"
                state={values}
                setState={setValues}
              />
              {!isEditing && <div className="flex align-bottom">
                <Input2
                  className="w-[300px]"
                  fieldName="Select template *"
                  optionDisplay="title"
                  optionKey="_id"
                  returnKey="templateId"
                  options={dropdown}
                  valueShowKey="title"
                  state={values}
                  setState={setValues}
                  type="drop"
                  didntShowKey
                  isArray={false}
                />
                <Button type='submit' onClick={handleNewDDFS} disabled={!values.title || !values.templateId || !!docId || loading}>
                  Submit
                </Button>
              </div>}
              {loading && <LoadingAnimation customHeight={100} customWidth={100} />}
              {docId && (<GoogleDocsCreator docId={docId} setDocId={setDocId} title={values.title} />)}
              {isEditing && <Button type='save' onClick={() => handleApprove(values)} >Save & Approve</Button>}
            </div>
          </Body>
        </Main>
      )}
      {myDoc.length > 0 && (
        <Main width='80vw' height='100%' zIndex='1000'>
          <Header>
            <Button
              type='close'
              onClick={() => {
                closeAnimation();
                setTimeout(() => { setMyDoc([]) }, 500);
              }}>
              Close
            </Button>
            <input placeholder="Search by ID/Title" value={search} onChange={(e) => setSearch(e.target.value)} type="text" className="w-72 h-[40px] mt-2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500" />

          </Header>
          <Body>
            <div className="flex flex-col w-full">
              {myDoc
                .filter((x: any) => {
                  if (search) {
                    const searchLower = search.toLowerCase();
                    return (
                      x.title?.toLowerCase().includes(searchLower) ||
                      x.ddfsId?.toLowerCase().includes(searchLower)
                    );
                  }
                  return true;
                })
                .map((item: any, index: number) => (
                  <div key={index} className="p-4 mb-4 bg-white shadow rounded-lg">
                    <h3 className="text-lg font-semibold">{item.title}</h3>
                    <p className="text-sm text-gray-600">ID: {item.ddfsId}</p>
                    <p className="text-sm text-gray-600">Created On: {new Date(item.createdOn).toString()}</p>
                    <MultiProgressBar points={item.status} />
                    {!item.status[0].completed && <div className="mt-2 flex space-x-2">

                      <Button
                        type="update"
                        onClick={() => {
                          setValues(item);
                          setDocId(item.docId);
                          setShowForm(true);
                          setIsEditing(true)
                        }}
                      >
                        Edit
                      </Button>
                      <Button type="delete" onClick={() => handleDelete(item._id, item.docId)}>
                        Delete
                      </Button>
                    </div>}
                  </div>
                ))}
            </div>
          </Body>
        </Main>
      )}
      {viewDocs && <GoogleDocsEditor setViewDocs={setViewDocs} viewDocs={viewDocs} />}
    </>
  )
}

export default DDFSDash